import { FC, ReactNode, useMemo } from 'react';
import usePoDetailsApi, { PoDetails, PoDetailsObject } from 'src/services/usePoDetailsApi';
import { PoDocuments } from 'src/services/usePoDocumentsApi';
import { SetState } from 'src/types/generic';
import { createContext } from 'use-context-selector';

interface PoRelatedDocumentsContextType {
  isLoading: boolean;
  poDocuments: PoDocuments;
  setPoDocuments: SetState<PoDocuments>;
  refresh: (params?: undefined) => Promise<PoDetailsObject>;
  poDetails: PoDetails;
  refreshPoDetails: () => Promise<PoDetails | undefined>;
}

export const PoRelatedDocumentsContext = createContext<PoRelatedDocumentsContextType>(
  {} as PoRelatedDocumentsContextType
);

interface Props {
  children: ReactNode;
  poId: string;
}

const PoRelatedDocumentsContextProvider: FC<Props> = ({ children, poId }) => {
  const {
    poDetails,
    refresh: refreshPoDetails,
    isLoading,
    poDocuments,
    setPoDocuments,
  } = usePoDetailsApi(poId);

  const values = useMemo(
    () => ({
      isLoading,
      poDocuments,
      setPoDocuments,
      refresh: refreshPoDetails,
      poDetails,
      refreshPoDetails,
    }),
    [isLoading, poDetails, poDocuments, refreshPoDetails, setPoDocuments]
  );

  return (
    <PoRelatedDocumentsContext.Provider value={values}>
      {children}
    </PoRelatedDocumentsContext.Provider>
  );
};

export default PoRelatedDocumentsContextProvider;
